<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="headReturn" v-if="localStepNum == 0">
      <span @click="returnBack">
        <i class="iconfont iconicon_fanhui" style="font-size:14px"></i>  返回列表</span
      >
      <span style="margin: 0 20px">|</span>
      <span class="name">{{ activityData.name }}</span>
    </div>
    <!-- 步骤条 -->
    <div class="step">
      <el-steps
        class="bz"
        :space="250"
        :active="localStepNum"
        finish-status="success"
        align-center
      >
        <el-step title="活动模板"></el-step>
        <el-step title="设置规则"></el-step>
        <el-step title="完成发布"></el-step>
      </el-steps>
    </div>

    <!-- 选中活动模板 -->
    <div class="firststep" v-if="localStepNum == 0">
      <div class="itemList">
        <div class="item">
          <div class="border"></div>
          <div class="wrapper">
            <img src="../../assets/images/integralCenter/ddzp.jpg" alt="" />
            <div class="mask">
              <div class="img">
                <div class="imgBg">
                  <!-- <img :src="activityData.telCode" alt="" /> -->
                  <div id="queryId" ref="queryId"></div>
                </div>
                <span class="tpl">手机扫码预览模板</span>
                <!-- <div id="qrcode" ref="qrcode" class="qrcodeIcon"></div> -->
              </div>
              <div>
                <el-button
                  type="primary"
                  size="medium"
                  @click="localStepNum = 1"
                  style="width: 168px"
                  >下一步，设置活动内容</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 活动条件表单设置 -->
    <div class="secondstep" v-if="localStepNum == 1">
      <div
        style="
          float: left;
          margin: -100px 0 0 10px;
          font-size: 16px;
          color: #2e3458;
          font-weight: bold;
        "
      >
        <span v-if="localStepNum == 1">大转盘抽奖</span>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="活动名称:" required>
          <!-- prop="activityName" 活动名称 -->
          <el-input
            v-model="ruleForm.activityName"
            maxlength="15"
            show-word-limit
            placeholder="请输入活动名称"
            style="width: 500px"
          ></el-input>
        </el-form-item>

        <el-form-item label="活动时间:" required>
          <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="ruleForm.startTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :disabled="disableTime == true"
              @change="activityTimeChange"
              :clearable="false"
            >
            </el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="ruleForm.endTime"
              default-time="23:59:59"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              @change="activityTimeChange"
              :clearable="false"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
            <img
              src="@/assets/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
          <span class="lastTime">
            活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
            <span style="color: #fe4d45">{{ timeOut }}</span> 小时
            <i class="el-icon-question"></i>
          </span>
        </el-form-item>

        <el-form-item label="活动条件:">
          <!-- prop="isFollow" 是否关注店铺 -->
          <el-checkbox
            label="关注店铺后方可参与活动"
            v-model="ruleForm.condFollow"
          ></el-checkbox>
        </el-form-item>

        <el-form-item label="抽奖条件:" required>
          <!-- prop="term" -->
          用户消耗
          <el-input
            v-model.number="bigTurntable.point"
            placeholder="请输入..."
            style="width: 80px"
            @input.native="checkputn"
          ></el-input>
          积分抽奖一次
        </el-form-item>

        <el-form-item label="抽奖和中奖限制:">
          <div class="limit">
            <p>
              每人<span class="c">每天</span>最多抽奖次数
              <el-input
                v-model.number="bigTurntable.oneDayMaxDrawNumber"
                placeholder="请输入..."
                @input.native="checkputn"
                style="width: 70px"
              ></el-input>
              次, 活动期间<span class="c">累计抽奖</span>最多
              <el-input
                v-model.number="bigTurntable.totalMaxDrawNumber"
                placeholder="请输入..."
                @input.native="checkputn"
                style="width: 70px"
              ></el-input>
              次,
            </p>
            <p>
              活动期间每人<span class="c">每天</span>中奖不超过
              <el-input
                v-model.number="bigTurntable.oneDayMaxRewardNumber"
                placeholder="请输入..."
                style="width: 70px"
                @input.native="checkputn"
              ></el-input>
              次, <span class="c">累计</span>中奖不超过
              <el-input
                v-model.number="bigTurntable.totalMaxRewardNumber"
                placeholder="请输入..."
                style="width: 70px"
                @input.native="checkputn"
              ></el-input>
              次,
            </p>
            <p class="desc">
              <img
                src="@/assets/images/new_icon_reminder1.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0 3px;
                "
              />
              此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
            </p>
          </div>
        </el-form-item>

        <el-form-item required>
          <span slot="label" class="set">奖品设置:</span>
          <div class="termAdd">
            <el-popover placement="right" width="270" trigger="hover">
              <img src="../../assets/images/integralCenter/wzsyt.png" alt="" />
              <span slot="reference">位置示意图</span>
            </el-popover>
            <p>
              累计中奖率: <span class="add">{{ winningRate }} %</span>
            </p>
          </div>
          <el-table
            :data="prizeSettingList"
            style="width: 100%; border: 1px solid #f0f0f0"
            :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
          >
            <el-table-column label="位置" >
              <template slot-scope="scope">
                <span v-if="scope.row.index == 0">一</span>
                <span v-if="scope.row.index == 1">二</span>
                <span v-if="scope.row.index == 2">三</span>
                <span v-if="scope.row.index == 3">四</span>
                <span v-if="scope.row.index == 4">五</span>
                <span v-if="scope.row.index == 5">六</span>
                <span v-if="scope.row.index == 6">七</span>
                <span v-if="scope.row.index == 7">八</span>
              </template>
            </el-table-column>

            <el-table-column label="选择奖品" >
              <template slot-scope="scope">
                <span class="s" @click="centerVis(scope.row)">选奖品</span>
              </template>
            </el-table-column>

            <el-table-column label="奖品类型" >
              <template slot-scope="scope">
                <span v-if="scope.row.prizeType == 1">优惠券</span>
                <span v-if="scope.row.prizeType == 2">京豆</span>
                <span v-if="scope.row.prizeType == 3">实物</span>
                <span v-if="scope.row.prizeType == 4">店铺积分</span>
                <span v-if="scope.row.prizeType == 5">京东E卡</span>
                <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                <span v-if="scope.row.prizeType == 8">现金红包</span>
                <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              </template>
            </el-table-column>

            <el-table-column label="值" width="80" prop="price">
              <!-- <template slot-scope="scope">
                {{ scope.row.price }}
              </template> -->
            </el-table-column>

            <el-table-column label="奖品名称（12字内）" width="299">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.title"
                  maxlength="12"
                  show-word-limit
                  style="width: 240px"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="奖品总数" width="180">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.totalAmount"
                  placeholder="请输入..."
                  style="width: 70px"
                  @input.native="checkputn"
                ></el-input>
                份
              </template>
            </el-table-column>

            <el-table-column label="中奖率">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.percentage"
                  placeholder="请输入..."
                  style="width: 70px"
                  @keyup.native="
                    scope.row.percentage = oninput2(scope.row.percentage)
                  "
                ></el-input>
                %
              </template>
            </el-table-column>

            <el-table-column label="图片" width="170">
              <template slot-scope="scope">
                <!-- <div v-if="scope.row.logo">
                  <el-upload
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    :on-change="handleChange"
                    :on-remove="handleRemove"
                    :http-request="httpRequest" 
                  > -->
                <img
                  v-if="scope.row.logo"
                  :src="scope.row.logo"
                  style="width: 56px; height: 56px"
                />
                <!-- <i class="el-icon-plus" v-else></i> -->
                <!-- </el-upload> -->
                <!-- <img
                    :src="scope.row.logo"
                    alt=""
                    class="imgTp"
                    style="width: 100%; height: 100%"
                  /> -->
                <!-- </div> -->
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="s" @click="cleanData(scope.row)">清除</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="tips">
                    <img
          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 9px 4px 0 3px;
          "
        />
            <span style="margin-left:21px">  说明</span>
            <p>
              1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
            </p>
            <p>
              2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
            </p>
            <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p>
            <p>
              4、实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
            </p>
          </div>
        </el-form-item>

        <el-form-item label="活动规则" required>
          <div
            style="
              width: 500px;
              padding: 8px;
                  background: #F9FAFB;
            "
          >
            <el-input
              maxlength="2000"
              type="textarea"
              class="textarea"
              style="width: 484px"
              resize="none"
              v-model="ruleForm.ruleDescription"
            ></el-input>

            <div>
              <el-button
                type="primary"
                class="generate"
                plain
                @click="generateRule"
                >生成规则</el-button
              >
              <span class="desc">
                 <img
          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 17px 4px 0px -13px;
          "
        />
                点击按钮自动生成规则，也可以自己编辑信息
              </span>
            </div>
          </div>
        </el-form-item>

        <el-form-item style="margin: 0 0 20px 0; text-align: center">
          <div style="text-align: center;    border-top: 1px solid #eee;
    padding:20px 0 10px 0 ;">
          <el-button
            v-show="!itemId"
            class="returnBtn"
            size="medium"
            @click="localStepNum = 0"
            >返回上一步</el-button
          >
          <el-button
            v-show="!itemId"
            class="keepBtn"
            type="primary"
            size="medium"
            @click="resetForm"
            v-preventReClick
            >保存并完成设置</el-button
          >

          <el-button
            v-show="itemId"
            class="returnBtn"
            size="medium"
            @click="cancelEdit"
            >取消</el-button
          >
          <el-button
            v-show="itemId"
            class="keepBtn"
            type="primary"
            size="medium"
            >保存并完成设置</el-button
          >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" @choose-shop="getTheData">
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
        <el-button @click="joinBlackList = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import {
  bigTurntableDraw,
  modifyBigTurn,
  getbigTurn,
} from "@/api/paradiseAndTaskCommonController.js";

import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";

export default {
  components: {
    selectProduct,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(3);
    },
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.qrcodeAll(this.activityData.telCode, queryId);
        });
      }
    },
  },
  data() {
    return {
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
      },
      ruleForm: {
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
      },
      bigTurntable: {
        point: null,
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      bigTurntableDrawS: [
        // {
        //   assetsId: 0,
        //   logo: "string",
        //   giftType: 0,
        //   logo: "string",
        //   percentage: 0,
        //   price: 0,
        //   prizeType: 0,
        //   singleAmount: 0,
        //   title: "string",
        //   totalAmount: 0,
        // },
      ],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,
    };
  },
  mounted() {
    this.getDetail();
    this.$nextTick(() => {
      this.qrcodeAll(this.activityData.telCode, queryId);
    });
    console.log(this.invalidateDate);
  },

  methods: {
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //上传图片
    handleChange(file, fileList) {
      console.log(file, fileList, 333333);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }
      if (this.ruleForm.condFollow == true) {
        text3 = "活动条件：关注店铺后方可参加活动";
      }
      if (this.bigTurntable.point) {
        text4 = "抽奖条件：用户消耗" + this.bigTurntable.point + "积分抽奖一次";
      }
      if (
        this.bigTurntable.oneDayMaxDrawNumber &&
        this.bigTurntable.totalMaxDrawNumber
      ) {
        if (
          this.bigTurntable.oneDayMaxRewardNumber &&
          this.bigTurntable.totalMaxRewardNumber
        ) {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次，活动期间每人每天中奖不超过" +
            this.bigTurntable.oneDayMaxRewardNumber +
            "次, 累计中奖不超过" +
            this.bigTurntable.totalMaxRewardNumber +
            "次";
        } else if (this.bigTurntable.oneDayMaxRewardNumber) {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次，活动期间每人每天中奖不超过" +
            this.bigTurntable.oneDayMaxRewardNumber +
            "次, 累计中奖不限次";
        } else if (this.bigTurntable.totalMaxRewardNumber) {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次, 活动期间每人每天中奖不限次，累计中奖不超过" +
            this.bigTurntable.totalMaxRewardNumber +
            "次";
        } else {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次";
        }
      }
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.ruleDescription = newText;
    },
    //清除
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(3);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      this.$refs.selectProduct.openDialog();
      this.index = row.index;
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, 2233);
      // console.log(this.index, 1111111111111);
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = Number(data.discount);

      this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = "店铺积分";
      } else {
        this.prizeSettingList[this.index].title = data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      console.log(this.prizeSettingList, 123);
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    
    // 下一步
    resetForm() {
      console.log(this.prizeSettingList, "obj");
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (!this.bigTurntable.point) {
        this.$message.warning("请输入抽奖条件");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      this.joinBlackList = true;
    },
    handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.bigTurntableDrawRuleDTO = this.bigTurntable;

      obj.bigTurntableDrawPrizeDTOS = this.deepClone(this.prizeSettingList);
      obj.bigTurntableDrawPrizeDTOS.forEach((item, index) => {
        item.percentage = Number(item.percentage);
      });
      if (this.checked == true) {
        if (this.ids == "") {
          bigTurntableDraw(obj)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                let routeUrl = this.$router.resolve({
                  path: "/integralCenter/integralEden",
                  query: { tabAct: 3 },
                });
                window.open(routeUrl.href, "_self");
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          modifyBigTurn(obj)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                let routeUrl = this.$router.resolve({
                  path: "/integralCenter/integralEden",
                  query: { tabAct: 3 },
                });
                window.open(routeUrl.href, "_self");
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
        // console.log(this.prizeSettingList, "obj");
        // this.$emit("saveEdit");
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        getbigTurn(id)
          .then((res) => {
            this.ruleForm = res.data;
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            this.bigTurntable = res.data.bigTurntableDrawRuleDTO;
            this.prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
            this.prizeSettingList.forEach((item, index) => {
              item.index = index;
            });
            this.activityTimeChange();
            console.log(res.data, this.prizeSettingList, "详情1");
            this.prizeSettingList.forEach((item) => {
              if (item.percentage) {
                this.winningRate += Number(item.percentage);
              }
            });
            this.winningRate = this.winningRate.toFixed(3);
          })
          .catch((res) => {});
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
    },
    // 活动时间改变
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
      console.log(end,invalidateDate);
      if (start < nowTime) {
        if (this.ids) {
          this.disableTime = true;
        } else {
          this.$message.warning("开始时间不能小于当前时间");
          // this.ruleForm.startTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.ruleForm.endTime = null;
        return;
      }
      if (end > invalidateDate) {
         this.$message.warning("活动时间不能超过软件有效期，请重新选择");
          this.ruleForm.endTime = null;
          return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.startTime.substring(0, 10);
      daysEnd = this.ruleForm.endTime.substring(0, 10);
      if (this.ruleForm.endTime != "" && this.ruleForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },

    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },

    //每日签到
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 82px;
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 40px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: rgba(250, 250, 250, 0.8);
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #fe4d45;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
<style lang="scss">
.createPlayStep {
  .el-step__head.is-success {
    color: #fe4d45;
    border-color: #fe4d45;
    .el-step__line {
      background-color: #fe4d45;
    }
  }
  .el-step__head.is-process {
    color: #fe4d45;
    border-color: #fe4d45;
  }
  .el-step__title.is-process {
    color: #fe4d45;
  }
  .el-step__title.is-success {
    color: #fe4d45;
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
}
</style>